// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-1mqZpiNE","list_box":"list_box-3r_YGAdV"};